module.exports = __webpack_public_path__ + "static/media/settings_16_white.0b2e7405.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/settings_16_white.svg
// module id = 619
// module chunks = 0